export default __webpack_public_path__ + "static/media/bg-01.81fb5209.png";